import plugin from '../../lib/plugin';

const PLUGIN_NAME = 'sortableProducts';
const ELEMENT_SELECTOR = '[data-sortable-products]';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--sortable-products" */ './sortable-products'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/sortable-products/index.js